// src/components/Header/index.jsx
import { Link } from 'react-router-dom';

const Header = () => {
  return (
    <header style={{ background: '#000', color: '#fff', padding: '0 24px', height: 64, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <h2 style={{ margin: 0 }}>
        <Link to="/" style={{ color: '#ffffffff', textDecoration: 'none' }}>NBA篮球博客</Link>
      </h2>
      <nav>
        <ul style={{ listStyle: 'none', margin: 0, padding: 0, display: 'flex', gap: 24 }}>
          <li><Link to="/" style={{ color: '#fff', textDecoration: 'none' }}>首页</Link></li>
          <li><Link to="/archive" style={{ color: '#fff', textDecoration: 'none' }}>历史文章</Link></li>
          <li><Link to="/writePost" style={{ color: '#fff', textDecoration: 'none' }}>写文章</Link></li>
          <li><Link to="/about" style={{ color: '#fff', textDecoration: 'none' }}>关于</Link></li>
          <li><Link to="/auth" style={{ color: '#fff', textDecoration: 'none' }}>登录</Link></li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;